<script>
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  mounted() {
    this.renderChart(
      {
        labels: [
          "VueJs",
          "EmberJs",
          "ReactJs",
          "AngularJs",
          "ee",
          "ws",
          "rt",
          "re"
        ],
        datasets: [
          {
            backgroundColor: [
              "#0D8E98",
              "#FEB11F",
              "#0B4C67",
              "#F1716C",
              "#CAC6BD",
              "#800517",
              "#F88017",
              "#839973"
            ],
            data: [10, 20, 10, 10, 10, 20, 10, 10]
          }
        ]
      },
      { responsive: true, maintainAspectRatio: true }
    );
  }
};
</script>
